// // import firebase from 'firebase/app';
// // import 'firebase/auth'; // Import Firebase services you need (e.g., Authentication)
// import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
// // import 'firebase/compat/firestore';
// // import "firebase/compat/database";
// // import "firebase/compat/storage";
// // const firebaseConfig = {
// //   // Paste your Firebase config object here
// //   apiKey: "YOUR_API_KEY",
// //   authDomain: "YOUR_AUTH_DOMAIN",
// //   projectId: "YOUR_PROJECT_ID",
// //   storageBucket: "YOUR_STORAGE_BUCKET",
// //   messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
// //   appId: "YOUR_APP_ID"
// // };

// // const firebaseConfig = {
 
// //     apiKey: "AIzaSyDca4O9PQMLlb1df1Pq8Md3Or3EhC8eJ2w",
   
// //     authDomain: "watania-uat.firebaseapp.com",
   
// //     databaseURL: "https://watania-uat-default-rtdb.firebaseio.com",
   
// //     projectId: "watania-uat",
   
// //     storageBucket: "watania-uat.appspot.com",
   
// //     messagingSenderId: "1078912325260",
   
// //     appId: "1:1078912325260:web:bd127294ea8c85dd2d8da9",
   
// //     measurementId: "G-2E4Y5HZS0C"
   
// // };

// const firebaseConfig = {
//     apiKey: "AIzaSyCuL_sND272h-lcwfcSk1K3NazY46Bzz9E",
//     authDomain:"account.insuranceinbox.in",
//     databaseURL: "https://insuranceinbox-auth-staging.firebaseio.com",
//     projectId:"insuranceinbox-auth-staging",
//     storageBucket: "insuranceinbox-auth.appspot.com",
//     messagingSenderId: "1012519333091"

// };

// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

// export default firebase;
//
//import { initializeApp } from 'firebase/app';
//import { getAuth, signInWithCustomToken } from 'firebase/auth';
//import firebase from 'firebase/app';
//
//const firebaseConfig = {
//    apiKey: "AIzaSyCuL_sND272h-lcwfcSk1K3NazY46Bzz9E",
//    authDomain:"account.insuranceinbox.in",
//    databaseURL: "https://insuranceinbox-auth-staging.firebaseio.com",
//    projectId:"insuranceinbox-auth-staging",
//    storageBucket: "insuranceinbox-auth.appspot.com",
//    messagingSenderId: "1012519333091"
//};
//
//const firebaseApp = initializeApp(firebaseConfig);
//
//
//export const auth = getAuth(firebaseApp);
//
//export const validateUserToken =  (token) =>{
//    console.log("token :>>>>>",token)
//    return signInWithCustomToken(auth,token);
//}
//
//
//export default firebaseApp;


import firebase from 'firebase/app';
import 'firebase/auth';  // Import Firebase Auth module

const firebaseConfig = {
  apiKey: "AIzaSyCuL_sND272h-lcwfcSk1K3NazY46Bzz9E",
  authDomain: "account.insuranceinbox.in",
  databaseURL: "https://insuranceinbox-auth-staging.firebaseio.com",
  projectId: "insuranceinbox-auth-staging",
  storageBucket: "insuranceinbox-auth.appspot.com",
  messagingSenderId: "1012519333091"
};


// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Get a reference to the auth service
export const auth = firebase.auth();

export  const validateUserToken = (token) => {
  console.log("token :>>>>>", token);
  return auth.signInWithCustomToken(token);
};

export default firebaseApp;